module.exports = __webpack_public_path__ + "static/media/fre-3.ec650c27.jpg";